import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPurchaseOrders = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.92 4.62A1 1 0 0 0 6 4H1.88A1 1 0 0 0 1 5v.12A1 1 0 0 0 2 6h3.24l4.58 16.33a4.5 4.5 0 1 0 6.13 3.5l13.55-3.64.11-.03a1 1 0 0 0 .6-1.19l-.04-.11a1 1 0 0 0-1.19-.6l-13.77 3.7a4.51 4.51 0 0 0-3.4-1.95L6.95 4.73l-.04-.11ZM9.1 27.15a2.5 2.5 0 1 1 4.82-1.3 2.5 2.5 0 0 1-4.82 1.3ZM25.06 5.63l.04.14 2.85 10.63a2 2 0 0 1-1.28 2.4l-.14.05-10.62 2.85a2 2 0 0 1-2.4-1.28l-.05-.14L10.6 9.66a2 2 0 0 1 1.27-2.4l.14-.05 10.63-2.85a2 2 0 0 1 2.4 1.27Zm-6.24 1.83 4.35-1.17L26 16.92 15.4 19.76 12.54 9.14l4.35-1.17 1.3 4.83 1.92-.51-1.29-4.83Z"
	})
});
export default SvgPurchaseOrders;
